import React from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';

import Omnisearch from '@buyside/components/presentation/Omnisearch/omnisearch';

import useDropdownButton from '@buyside/util/hooks/useDropdownButton';
import { useIsMobile } from '@buyside/util/hooks/useIsMobile';

import styles from './navigationSearchStyles.scss';

const NavigationSearch: React.FC<{ canWriteIdeas: boolean }> = ({ canWriteIdeas }) => {
  const isMobile = useIsMobile();

  const { dropdownRef, dropdownVisible, toggleDropdown } = useDropdownButton();

  return isMobile ? (
    <div ref={dropdownRef} className={styles.dropdown}>
      <button
        className={classNames(styles.dropdownButton, {
          [styles.active]: dropdownVisible
        })}
        onClick={toggleDropdown}
      >
        <FontAwesomeIcon icon={faSearch} />
      </button>
      <div
        className={classNames(styles.dropdownAreaWrapper, {
          [styles.visible]: dropdownVisible
        })}
      >
        <div
          className={classNames(styles.dropdownArea, {
            [styles.dropdownAreaVisible]: dropdownVisible
          })}
        >
          <div className={styles.dropdownHeader}>Search SumZero</div>
          <div className={styles.omnisearch} data-heap="search">
            <Omnisearch canWriteIdeas={canWriteIdeas} />
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div data-heap="search">
      <Omnisearch canWriteIdeas={canWriteIdeas} />
    </div>
  );
};

export default NavigationSearch;
